// extracted by mini-css-extract-plugin
export const root = "logo-module--root--o8wuu";
export const light = "logo-module--light--3rM3B";
export const dark = "logo-module--dark--1bH7T";